import { useSelector } from 'react-redux';
import useSWR from 'swr';

import {
    authenticationSettingUrl,
    getAllAuthenticationSettings
    ,
} from '../../services/identity/AuthenticationSettingService';
import {
    accountGlobalId,
    isHostModeSelector,
} from '../../store/selectors';

export const useCheckAuthenticationSetting = () => {
    const partitionGlobalId = useSelector(accountGlobalId);
    const isHost = useSelector(isHostModeSelector);
    const { data: authenticationSetting } = useSWR(
        !isHost ? {
            url: `${authenticationSettingUrl}/getAll`,
            partitionGlobalId,
        } : null,
        getAllAuthenticationSettings,
    );
    return authenticationSetting;
};
